import { render, staticRenderFns } from "./couponStat.vue?vue&type=template&id=223b44fc&"
import script from "./couponStat.vue?vue&type=script&lang=js&"
export * from "./couponStat.vue?vue&type=script&lang=js&"
import style0 from "./couponStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports